<!--科研成果 成就页面 -->
<template>
  <div class="achievementsList">
    <div class="nav clearfix">
      <div class="scienceNav">
        科研成果
        <div class="icon"></div>
      </div>
      <div class="cooperationNav" @click="gotoCooperation">孵化合作</div>
    </div>
    <van-list
      :immediate-check="false"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="science clearfix"
        v-for="item in achievementsList"
        :key="item.sId"
        @click="gotoAchievementsDetail(item.sId)"
      >
        <div class="scienceImgDiv">
          <img :src="item.achievement_img" alt="图片" class="scienceImg" />
        </div>
        <div class="scienceData">
          <div class="scienceName">{{ item.sName }}</div>
          <div class="scienceDescribe">{{ item.sDescription }}</div>
          <div class="date">{{ item.sCreateTime }}</div>
        </div>
      </div>
    </van-list>
    <div class="issue" @click="gotoIssue">发布</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      lastPage: "",
      achievementsList: [],
      loading: false,
      finished: false,
    };
  },
  created() {
    this.getScienceList();
  },
  methods: {
    async getScienceList() {
      const result = await this.$http.get("/achievementTransform/getAllAchievementList", {
        params: { currentPage: this.page, perpage: this.pageSize },
      });
      for (let i = 0; i < result.data.list.length; i++) {
        this.achievementsList.push(result.data.list[i]);
      }
      this.lastPage = result.data.lastPage;
    },
    // 懒加载
    onLoad() {
      this.page = this.page + 1;
      this.getScienceList();
      this.loading = false;
      // 数据全部加载完成
      if (this.page >= this.lastPage) {
        this.finished = true;
      }
    },
    gotoIssue() {
      return this.$router.push("/addAchievements");
    },
    gotoCooperation() {
      return this.$router.push("/cooperation");
    },
    gotoAchievementsDetail(sId) {
      return this.$router.push({
        path: "/achievementsDetail",
        query: { id: sId },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.achievementsList {
  position: relative;
  min-height: 100vh;
  .nav {
    position: relative;
    left: 25%;
    width: 50%;
    padding-top: 15px;
    .scienceNav {
      position: relative;
      float: left;
      font-size: 1.2rem;
      font-weight: bold;
      color: #333333;
      .icon {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 3px;
        width: 7vw;
        height: 2px;
        border-radius: 2px;
        background-color: #00706E;
      }
    }
    .cooperationNav {
      float: right;
      font-size: 1.1rem;
      font-weight: bold;
      color: #999999;
    }
  }
  .science {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 15px 0;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .scienceImgDiv {
      float: left;
      width: 33%;
      height: 22vw;
      margin: 10px;
      .scienceImg {
        height: 100%;
        width: 100%;
        border-radius: 15px;
      }
    }
    .scienceData {
      float: left;
      margin-top: 10px;
      width: 58%;
      .scienceName {
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .scienceDescribe {
        margin-top: 5px;
        font-weight: 400;
        color: #333333;
        line-height: 1.5em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .date {
        position: absolute;
        bottom: 10px;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .issue {
    position: fixed;
    right: 5%;
    top: 70%;
    height: 13.5vw;
    width: 14%;
    background-color: rgb(111, 167, 251);
    border-radius: 200px;
    text-align: center;
    line-height: 13.5vw;
    color: white;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/achievements/AchievementsList.vue